const { ApolloClient, InMemoryCache, createHttpLink, ApolloLink } = require('@apollo/client');
const { onError } = require('@apollo/client/link/error');

const config = {
  graphqlUrl: window.__CONFIG__?.graphqlUrl || 'http://localhost:4000/graphql'
};

const graphqlUri = config.apolloClient?.httpLink?.uri || '/graphql';
const createClient = (ssrMode = false, initialState = {}) => {
  const linkOptions = {
    uri: graphqlUri,
    credentials: 'include',
    fetchOptions: { 
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      }
    },
  };

  // Logging link dla śledzenia zapytań
  const loggingLink = new ApolloLink((operation, forward) => {
    const operationName = operation.operationName;
    const operationsToLog = [];

    console.log(`[GraphQL] Operation: ${operationName || 'unknown'}`);

    if (!operationName || operationsToLog.includes(operationName)) {
      console.log('[GraphQL] Query:', operation.query.loc?.source.body);
      console.log('[GraphQL] Variables:', JSON.stringify(operation.variables, null, 2));
    }

    const startTime = Date.now();

    return forward(operation).map(response => {
      const duration = Date.now() - startTime;
      console.log(`[GraphQL] ${operationName || 'unknown'} completed in ${duration}ms`);

      if (!operationName || operationsToLog.includes(operationName)) {
        if (response.errors) {
          console.error(`[GraphQL] ${operationName || 'unknown'} errors:`, JSON.stringify(response.errors, null, 2));
        } else {
          console.log(`[GraphQL] ${operationName || 'unknown'} success`);
        }
      }

      return response;
    });
  });

  // Error link dla obsługi błędów
  const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path }) => {
        console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}, Operation: ${operation.operationName}`);
      });
    }
    if (networkError) {
      console.log(`[Network error]: ${networkError}`);
      console.log(`[Request details]: URI: ${linkOptions.uri}, Operation: ${operation.operationName}, Variables:`, operation.variables);
    }
  });

  const httpLink = createHttpLink(linkOptions);
  const link = ApolloLink.from([loggingLink, errorLink, httpLink]);

  const cache = new InMemoryCache({
    possibleTypes: {
      ProductInterface: ["SimpleProduct", "GroupedProduct", "ConfigurableProduct", "VirtualProduct", "DownloadableProduct", "BundleProduct", "GiftCardProduct"],
      CartItemInterface: ["SimpleCartItem", "VirtualCartItem", "DownloadableCartItem", "ConfigurableCartItem", "BundleCartItem", "GiftCardCartItem"],
      PhysicalProductInterface: ["SimpleProduct", "BundleProduct", "GroupedProduct", "ConfigurableProduct", "GiftCardProduct"]
    },
    typePolicies: {
      Query: {
        fields: {
          users: {
            merge(existing = [], incoming) {
              return [...incoming];
            }
          },
          cart: {
            // Cache cart aggressively to prevent unnecessary refetches
            fetchPolicy: 'cache-first'
          }
        }
      }
    }
  }).restore(initialState);

  return new ApolloClient({
    ssrMode,
    link,
    cache,
    defaultOptions: {
      query: {
        fetchPolicy: ssrMode ? 'network-only' : 'cache-first',
        errorPolicy: 'all',
        context: { timeout: 3000 }
      },
      watchQuery: {
        fetchPolicy: ssrMode ? 'network-only' : 'cache-and-network',
        errorPolicy: 'all',
      },
      mutate: { errorPolicy: 'all' }
    },
    connectToDevTools: process.env.NODE_ENV === 'development',
    assumeImmutableResults: true,
    queryDeduplication: true
  });
};

module.exports = { createClient };
